<template>
  <div :class="bem()">
    <slot name="header" v-if="poolsFiltered.length > 0"></slot>
    <div v-for="pool in poolsFiltered" :key="pool.pool_id" :class="checkedPools[pool.pool_id] ? bem('item', 'active') : bem('item')">
      <v-layout row wrap >
        <v-flex xs7>
          <!-- value: used when we click on clear refinements -->
          <v-checkbox
            :label="`${pool.name} (${pool.pool_document_length})`"
            :value="checkedPools[pool.pool_id]"
            class="ais_refinement_list_checkbox"
            @change="togglePools(pool.pool_id);" ></v-checkbox>
        </v-flex>
        <v-flex xs5 class="text-xs-right">
          <v-menu
            :close-on-content-click="false"
            :nudge-width='200'
            offset-x >
            <v-btn v-if="allowEdit" class="edit_bookmark_btn hidden-md-and-down" slot="activator" small outline fab @click="show_edit_bookmark(parseInt(pool.pool_id))">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-card style="border: 1 solid #aaa">
            <v-list>
              <v-list-tile>
                <v-list-tile-title><b>Manage <i><span v-text="pool.name" /></i></b></v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile v-for="document in userPoolDocuments" :key="document.document_id">
                <v-list-tile-title v-text="document.title_en" style="max-width: 700px;" />
                <v-list-tile-action>
                  <v-btn flat @click="removeDocumentFromPool(parseInt(pool.pool_id), parseInt(document.document_id))"><v-icon>delete</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            </v-card>
          </v-menu>
          <v-menu
            v-if="parseInt(pool.pool_id) !== 146"
            :close-on-content-click="false"
            :nudge-width='200'
            offset-x
            v-model="deleteMenu[pool.pool_id]">
            <v-btn class="edit_bookmark_btn" slot="activator" small outline fab>
              <v-icon>delete</v-icon>
            </v-btn>
            <v-card style="border: 1 solid #aaa">
            <v-list>
              <v-list-tile>
                <v-list-tile-title>Are you sure?</v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-btn flat @click="deleteMenu[pool.pool_id] = false">Cancel</v-btn>
                </v-list-tile-action>
                <v-spacer/>
                <v-list-tile-action>
                  <v-btn color="error darken-1" @click="delete_pool(parseInt(pool.pool_id))">Delete</v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            </v-card>
          </v-menu>
        </v-flex>
      </v-layout>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import { FACET_OR, FACET_AND, Component } from 'vue-instantsearch'
import { mapState, mapMutations } from 'vuex'
import POOLS from '@/graphql/Pools.gql'
import DELETE_POOLS from '@/graphql/DeletePools.gql'
import REMOVE_DOCUMENTS_FROM_POOL from '@/graphql/RemoveDocumentsFromPool.gql'
import GET_POOL_DOCUMENTS_BY_POOL_ID from '@/graphql/GetPoolDocumentsByPoolId.gql'

export default {
  name: 'ais-pools',
  mixins: [Component],
  props: {
    attributeName: {
      type: String,
      required: true
    },
    operator: {
      type: String,
      default: FACET_OR,
      validator (rawValue) {
        const value = rawValue.toLowerCase()
        return value === FACET_OR || value === FACET_AND
      }
    },
    allowEdit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      pools: [],
      userPoolDocuments: [],
      blockClassName: 'ais-pools',
      deleteMenu: {}
    }
  },
  destroyed () {
    this.searchStore.stop()
    this.searchStore.removeFacet(this.attributeName)
    this.searchStore.start()
  },
  computed: {
    ...mapState('searchEnginePage', ['checkedPools']),
    poolsFiltered () {
      return this.pools ? this.pools.filter(p => p.document_type === this.$route.name ? p : false) : []
    }
  },
  methods: {
    ...mapMutations(['addError']),
    ...mapMutations('searchEnginePage', ['setCheckedPools']),
    togglePools (poolId) {
      let checkedPoolsTmp = Object.assign({}, this.checkedPools)
      if (this.checkedPools[poolId] === undefined || this.checkedPools[poolId] === false) {
        checkedPoolsTmp[poolId] = true
      } else {
        checkedPoolsTmp[poolId] = false
      }
      this.setCheckedPools(checkedPoolsTmp)

      this.searchStore.page = 1
      this.searchStore.refresh()
    },
    show_edit_bookmark (poolId) {
      this.$apollo.query({
        query: GET_POOL_DOCUMENTS_BY_POOL_ID,
        variables: {
          pool_id: poolId
        }
      }).then(response => {
        this.userPoolDocuments = response.data.getPoolDocumentsByPoolId
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    },
    async delete_pool (poolId) {
      this.$apollo.mutate({
        mutation: DELETE_POOLS,
        variables: {
          pool_ids: [poolId]
        },
        update: (store, { data: { poolId } }) => {
          this.$apollo.queries.pools.refetch()
        }
      }).then((data) => {
        this.deleteMenu[poolId] = false
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    },
    async removeDocumentFromPool (poolId, documentId) {
      this.$apollo.mutate({
        mutation: REMOVE_DOCUMENTS_FROM_POOL,
        variables: {
          pool_id: poolId,
          document_ids: [documentId]
        },
        update: (store) => {
          const data = store.readQuery({
            query: GET_POOL_DOCUMENTS_BY_POOL_ID,
            variables: {
              pool_id: poolId
            }
          })
          const documentIndex = data.getPoolDocumentsByPoolId.findIndex(document => document.document_id === documentId)
          if (documentIndex !== -1) {
            data.getPoolDocumentsByPoolId.splice(documentIndex, 1)
          }
          store.writeQuery({ query: GET_POOL_DOCUMENTS_BY_POOL_ID, data })
          this.$apollo.queries.pools.refetch()
        }
      }).then((data) => {
        this.deleteMenu[poolId] = false
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    }
  },
  apollo: {
    pools: {
      query: POOLS
    }
  }
}
</script>
<style>
.ais-pools {
  margin-bottom: 10px;
}
.ais-pools h3 {
  margin-top: 2px;
}
.ais-pools .v-input__control {
  height: 28px;
}
.ais-pools__item {
  background-color: #fafafa;
  max-width: 98%;
}
.ais-pools .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.ais-pools .v-input--selection-controls .v-input__slot {
  margin-bottom: 0px;
}
.ais-pools .v-input__slot {
  margin-bottom: 0px;
}

.edit_bookmark_btn {
  border: none!important;
  height: 34px!important;
  width: 34px!important;
  margin: 0px;
  bottom: 4.5px;
}

.edit_bookmark_btn .v-icon {
  color: rgba(0,0,0,.54)!important;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box!important;
  display: -ms-inline-flexbox!important;
  display: inline-flex!important;
  -webkit-box-flex: 1;
  font-size: 24px!important;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  height: 24px;
  -webkit-box-pack: center;
  -ms-flex-pack: center!important;
  justify-content: center;
  min-width: 24px;
  width: 24px;
}

.edit_bookmark_menu_mdAndDown {
  max-width: 100%!important;
  left: 161px!important;
}

</style>
